<template>
  <AdminLayout>
    <template #content>
      <div class="settings-layout">
        <header class="settings-layout-header">
          <div>
            <h1 class="h4 mb-1">Paramètres</h1>
            <small class="text-muted">Réglages du site, des préférences utilisateur et des modules.</small>
          </div>
        </header>

        <div class="settings-layout-body">
          <aside class="settings-sidebar" aria-label="Sous-navigation des paramètres">
            <router-link
              v-for="item in navItems"
              :key="item.name"
              class="settings-sidebar-link"
              :class="{ active: isActive(item.active) }"
              :to="{ name: item.name }"
            >
              <i :class="item.icon"></i>
              <span>{{ item.label }}</span>
            </router-link>
          </aside>

          <section class="settings-content-card">
            <slot name="content"></slot>
          </section>
        </div>
      </div>
    </template>
  </AdminLayout>
</template>

<script>
import AdminLayout from '@/layouts/AdminLayout.vue';
import { hasPermission } from '@/support/permissions';
import { visibleSettingsNavItems } from '@/support/settingsNavigation';

export default {
  name: 'SettingsLayout',
  components: {
    AdminLayout,
  },
  computed: {
    navItems() {
      const ecommerceEnabled = this.$store.getters['runtime/moduleEnabled']('ecommerce');
      const shop = this.$store.getters['shop/shopInfo'];
      const canConfigureEcommerce = ecommerceEnabled
        && shop?.is_main === true
        && shop?.ecommerce_enabled === true;

      return visibleSettingsNavItems(ecommerceEnabled, canConfigureEcommerce).filter((item) => {
        const permission = item.permission || 'settings.view';
        const module = permission.split('.', 1)[0];

        return this.$store.getters['runtime/moduleEnabled'](module)
          && hasPermission(this.$store.getters['auth/currentUser'], permission);
      });
    },
  },
  methods: {
    isActive(names) {
      return names.includes(String(this.$route.name));
    },
  },
};
</script>

<style scoped>
.settings-layout {
  display: grid;
  gap: 1rem;
}

.settings-layout-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.settings-layout-body {
  align-items: start;
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(220px, 260px) minmax(0, 1fr);
}

.settings-sidebar {
  background: var(--suite241-card-bg, #ffffff);
  border: 1px solid var(--suite241-card-border, #e2e8f0);
  border-radius: 8px;
  display: grid;
  gap: 0.3rem;
  padding: 0.45rem;
  position: sticky;
  top: 5.5rem;
}

.settings-sidebar-link {
  align-items: center;
  border-radius: 7px;
  color: #475569;
  display: flex;
  gap: 0.65rem;
  padding: 0.7rem 0.75rem;
  text-decoration: none;
  transition:
    background-color 0.18s ease,
    color 0.18s ease,
    transform 0.12s ease;
}

.settings-sidebar-link i {
  color: #64748b;
  text-align: center;
  width: 18px;
}

.settings-sidebar-link span {
  font-size: 0.86rem;
  font-weight: 800;
}

.settings-sidebar-link:hover {
  background: var(--suite241-admin-accent-soft, #f1f5f9);
  color: #0f172a;
}

.settings-sidebar-link.active {
  background: var(--suite241-admin-primary, #0d6efd);
  color: #ffffff;
  transform: translateX(2px);
}

.settings-sidebar-link.active i {
  color: #ffffff;
}

.settings-content-card {
  background: var(--suite241-card-bg, #ffffff);
  border: 1px solid var(--suite241-card-border, #e5e7eb);
  border-radius: 8px;
  box-shadow: 0 0.35rem 1rem rgba(15, 23, 42, 0.06);
  min-width: 0;
  padding: 1rem;
}

@media (max-width: 991.98px) {
  .settings-layout-body {
    grid-template-columns: 1fr;
  }

  .settings-sidebar {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    position: static;
  }

  .settings-sidebar::-webkit-scrollbar:vertical {
    display: none;
    width: 0;
  }

  .settings-sidebar-link {
    flex: 0 0 auto;
    font-size: 0.78rem;
    white-space: nowrap;
  }

  .settings-content-card {
    padding: 0.85rem;
  }
}

@media (max-width: 575.98px) {
  .settings-sidebar-link {
    font-size: 0.72rem;
    padding: 0.65rem 0.75rem;
  }
}
</style>
